import { useSupplierType } from './useSupplierType';
import { useSelector } from 'react-redux';
import { validateSupplier, validateSupplierCarrierUsers} from 'utils/supplierValidations';

export function useSupplierTypeValidation() {
  const { isDirectSupplier, isIndirectSupplier } = useSupplierType();

  // TODO: See if user is needed
  const user = useSelector(state => state.user)
  const formState = useSelector(state => state.forms)

  const validation = validateSupplier({ user, formState, isDirectSupplier, isIndirectSupplier })
  const logValidation = () => { 
    console.log("Supplier validation:", validation)
  }

  return { isValid: validation.valid, logValidation }
}

export function useSupplierCarrierUsersValidation() {
  const { isDirectSupplier, isIndirectSupplier } = useSupplierType();
  const formState = useSelector(state => state.forms);

  const validation = validateSupplierCarrierUsers({formState,isDirectSupplier, isIndirectSupplier});

  return { isValidCarrierUsers: validation.valid}
}
